export default __webpack_public_path__ + "static/invertt-3f999641e7899835007ee28aa0fadfe5.png";